type ErrorKey = {
    message: string;
};

type ErrorMap = Record<string, string>;

export const resolveMostPreciseTranslationKey = (
    errorKeys: ErrorKey[],
): string => {
    const errorTranslationKeys = errorKeys.map((key) =>
        getOrDefault(key.message),
    );

    const errorPrio = [DefaultReceiverAddressError, DefaultError];
    const prioritizedKeys = errorTranslationKeys.sort((a, b) => {
        const aPrio = errorPrio.indexOf(a);
        const bPrio = errorPrio.indexOf(b);

        return aPrio - bPrio;
    });

    return prioritizedKeys[0];
};

export const isUnSupportedProduct = (error: ErrorKey): boolean =>
    error.message ===
    `${Shipment}:${ValidatedProperty.Product}:${ValidationErrorType.NotSupported}`;

export const getDefaultErrorKey = (): string => DefaultError;

const getOrDefault = (errorCode: string): string => {
    const error = errorMap[errorCode];
    if (!error) return DefaultError;

    return error;
};

const Unknown = 'Unknown';
const ReceiverAddress = 'ReceiverAddress';
const Shipment = 'Shipment';
const SenderAddress = 'SenderAddress';
const AgentAddress = 'AgentAddress';
const Product = 'Product';

const ValidatedProperty = {
    Unknown: 'Unknown',
    Street: 'Street',
    ZipCode: 'ZipCode',
    City: 'City',
    CountryCode: 'CountryCode',
    Email: 'Email',
    Phone: 'Phone',
    Length: 'Length',
    Width: 'Width',
    Height: 'Height',
    Weight: 'Weight',
    Product: 'Product',
    Type: 'Type',
    Name: 'Name',
    Agent: 'Agent',
};

const ValidationErrorType = {
    Unknown: 'Unknown',
    Missing: 'Missing',
    WrongFormat: 'WrongFormat',
    NotReal: 'NotReal',
    ZipcodeRouting: 'ZipcodeRouting',
    NotSupported: 'NotSupported',
    NotEnabled: 'NotEnabled',
};

export const DefaultReceiverAddressError =
    'shipping_validation_defaultReceiverAddress';
export const CheckReceiverZipCodeError =
    'shipping_validation_checkReceiverZipCode';
export const CheckReceiverPhoneError = 'shipping_validation_checkReceiverPhone';
export const ReceiverAgentMissingError =
    'shipping_validation_receiverAgentMissing';
export const CheckAddressesError = 'shipping_validation_checkAddresses';
export const DefaultError = 'shipping_validation_default';
export const GenericShippingError = 'shipping_checkout_something_went_wrong';

const CheckReceiverEmailError = 'shipping_validation_checkReceiverEmail';
const InvalidCountryCodeError = 'shipping_validation_invalidCountryCode';
const DefaultSenderAddressError = 'shipping_validation_defaultSenderAddress';
const CheckSenderEmailError = 'shipping_validation_checkSenderEmail';
const CheckSenderPhoneError = 'shipping_validation_checkSenderPhone';
const CheckSenderZipCodeError = 'shipping_validation_checkSenderZipCode';
const DefaultAgentAddressError = 'shipping_validation_defaultAgentAddress';
const BadZipCodeError = 'shipping_validation_badZipCode';
const DefaultProductNotEnabledError =
    'shipping_validation_defaultProductNotEnabled';

const errorMap: ErrorMap = {
    [`${ReceiverAddress}:${ValidatedProperty.City}:${ValidationErrorType.Missing}`]:
        DefaultReceiverAddressError,
    [`${ReceiverAddress}:${ValidatedProperty.City}:${ValidationErrorType.WrongFormat}`]:
        DefaultReceiverAddressError,
    [`${ReceiverAddress}:${ValidatedProperty.CountryCode}:${ValidationErrorType.Missing}`]:
        DefaultReceiverAddressError,
    [`${ReceiverAddress}:${ValidatedProperty.CountryCode}:${ValidationErrorType.NotSupported}`]:
        InvalidCountryCodeError,
    [`${ReceiverAddress}:${ValidatedProperty.CountryCode}:${ValidationErrorType.WrongFormat}`]:
        DefaultReceiverAddressError,
    [`${ReceiverAddress}:${ValidatedProperty.Email}:${ValidationErrorType.Missing}`]:
        CheckReceiverEmailError,
    [`${ReceiverAddress}:${ValidatedProperty.Email}:${ValidationErrorType.WrongFormat}`]:
        CheckReceiverEmailError,
    [`${ReceiverAddress}:${ValidatedProperty.Name}:${ValidationErrorType.Missing}`]:
        DefaultReceiverAddressError,
    [`${ReceiverAddress}:${ValidatedProperty.Name}:${ValidationErrorType.WrongFormat}`]:
        DefaultReceiverAddressError,
    [`${ReceiverAddress}:${ValidatedProperty.Phone}:${ValidationErrorType.Missing}`]:
        CheckReceiverPhoneError,
    [`${ReceiverAddress}:${ValidatedProperty.Phone}:${ValidationErrorType.WrongFormat}`]:
        CheckReceiverPhoneError,
    [`${ReceiverAddress}:${ValidatedProperty.Street}:${ValidationErrorType.Missing}`]:
        DefaultReceiverAddressError,
    [`${ReceiverAddress}:${ValidatedProperty.Street}:${ValidationErrorType.WrongFormat}`]:
        DefaultReceiverAddressError,
    [`${ReceiverAddress}:${ValidatedProperty.Unknown}:${ValidationErrorType.Missing}`]:
        DefaultReceiverAddressError,
    [`${ReceiverAddress}:${ValidatedProperty.ZipCode}:${ValidationErrorType.Missing}`]:
        DefaultReceiverAddressError,
    [`${ReceiverAddress}:${ValidatedProperty.ZipCode}:${ValidationErrorType.NotReal}`]:
        CheckReceiverZipCodeError,
    [`${ReceiverAddress}:${ValidatedProperty.ZipCode}:${ValidationErrorType.NotSupported}`]:
        CheckReceiverZipCodeError,
    [`${ReceiverAddress}:${ValidatedProperty.ZipCode}:${ValidationErrorType.WrongFormat}`]:
        CheckReceiverZipCodeError,
    [`${ReceiverAddress}:${ValidatedProperty.Agent}:${ValidationErrorType.Missing}`]:
        ReceiverAgentMissingError,

    [`${Shipment}:${ValidatedProperty.Agent}:${ValidationErrorType.Missing}`]:
        DefaultError,
    [`${Shipment}:${ValidatedProperty.City}:${ValidationErrorType.Missing}`]:
        DefaultError,
    [`${Shipment}:${ValidatedProperty.Height}:${ValidationErrorType.Missing}`]:
        DefaultError,
    [`${Shipment}:${ValidatedProperty.Length}:${ValidationErrorType.Missing}`]:
        DefaultError,
    [`${Shipment}:${ValidatedProperty.Street}:${ValidationErrorType.Missing}`]:
        DefaultError,
    [`${Shipment}:${ValidatedProperty.Unknown}:${ValidationErrorType.Unknown}`]:
        DefaultError,
    [`${Shipment}:${ValidatedProperty.Unknown}:${ValidationErrorType.ZipcodeRouting}`]:
        CheckAddressesError,
    [`${Shipment}:${ValidatedProperty.Weight}:${ValidationErrorType.Missing}`]:
        DefaultError,
    [`${Shipment}:${ValidatedProperty.Width}:${ValidationErrorType.Missing}`]:
        DefaultError,
    [`${Shipment}:${ValidatedProperty.ZipCode}:${ValidationErrorType.NotReal}`]:
        BadZipCodeError,
    [`${Shipment}:${ValidatedProperty.ZipCode}:${ValidationErrorType.WrongFormat}`]:
        DefaultError,

    [`${SenderAddress}:${ValidatedProperty.City}:${ValidationErrorType.Missing}`]:
        DefaultSenderAddressError,
    [`${SenderAddress}:${ValidatedProperty.City}:${ValidationErrorType.WrongFormat}`]:
        DefaultSenderAddressError,
    [`${SenderAddress}:${ValidatedProperty.CountryCode}:${ValidationErrorType.Missing}`]:
        DefaultSenderAddressError,
    [`${SenderAddress}:${ValidatedProperty.CountryCode}:${ValidationErrorType.WrongFormat}`]:
        DefaultSenderAddressError,
    [`${SenderAddress}:${ValidatedProperty.Email}:${ValidationErrorType.Missing}`]:
        CheckSenderEmailError,
    [`${SenderAddress}:${ValidatedProperty.Email}:${ValidationErrorType.WrongFormat}`]:
        CheckSenderEmailError,
    [`${SenderAddress}:${ValidatedProperty.Name}:${ValidationErrorType.Missing}`]:
        DefaultSenderAddressError,
    [`${SenderAddress}:${ValidatedProperty.Name}:${ValidationErrorType.WrongFormat}`]:
        DefaultSenderAddressError,
    [`${SenderAddress}:${ValidatedProperty.Phone}:${ValidationErrorType.Missing}`]:
        CheckSenderPhoneError,
    [`${SenderAddress}:${ValidatedProperty.Phone}:${ValidationErrorType.WrongFormat}`]:
        CheckSenderPhoneError,
    [`${SenderAddress}:${ValidatedProperty.Street}:${ValidationErrorType.Missing}`]:
        DefaultSenderAddressError,
    [`${SenderAddress}:${ValidatedProperty.Street}:${ValidationErrorType.WrongFormat}`]:
        DefaultSenderAddressError,
    [`${SenderAddress}:${ValidatedProperty.Unknown}:${ValidationErrorType.Missing}`]:
        DefaultSenderAddressError,
    [`${SenderAddress}:${ValidatedProperty.ZipCode}:${ValidationErrorType.Missing}`]:
        DefaultSenderAddressError,
    [`${SenderAddress}:${ValidatedProperty.ZipCode}:${ValidationErrorType.NotReal}`]:
        DefaultSenderAddressError,
    [`${SenderAddress}:${ValidatedProperty.ZipCode}:${ValidationErrorType.NotSupported}`]:
        CheckSenderZipCodeError,
    [`${SenderAddress}:${ValidatedProperty.ZipCode}:${ValidationErrorType.WrongFormat}`]:
        CheckSenderZipCodeError,

    [`${AgentAddress}:${ValidatedProperty.Unknown}:${ValidationErrorType.WrongFormat}`]:
        DefaultAgentAddressError,
    [`${AgentAddress}:${ValidatedProperty.Street}:${ValidationErrorType.WrongFormat}`]:
        DefaultAgentAddressError,
    [`${AgentAddress}:${ValidatedProperty.ZipCode}:${ValidationErrorType.WrongFormat}`]:
        DefaultAgentAddressError,
    [`${AgentAddress}:${ValidatedProperty.City}:${ValidationErrorType.WrongFormat}`]:
        DefaultAgentAddressError,
    [`${AgentAddress}:${ValidatedProperty.CountryCode}:${ValidationErrorType.WrongFormat}`]:
        DefaultAgentAddressError,

    [`${Product}:${ValidatedProperty.Type}:${ValidationErrorType.NotEnabled}`]:
        DefaultProductNotEnabledError,

    [`${Unknown}:${ValidatedProperty.Unknown}:${ValidationErrorType.Unknown}`]:
        DefaultError,
};
